import { MAX_FILE_BYTES, ACCEPTED_FILE_TYPES } from "../utils/submitForm";

const fmtSize = bytes => bytes < 1024 * 1024
  ? `${Math.round(bytes / 1024)} KB`
  : `${(bytes / (1024 * 1024)).toFixed(1)} MB`;

/**
 * Multi-file picker with client-side size/type validation.
 * `files`/`setFiles` hold an array of File objects; `label`/`hint` describe
 * what's expected (e.g. "CV / Resume", "PDF, DOC or image, max 10MB each").
 */
export default function FileUploadField({ label, hint, files, setFiles, onError }) {
  const addFiles = fileList => {
    const incoming = Array.from(fileList);
    const accepted = [];
    for (const file of incoming) {
      if (file.size > MAX_FILE_BYTES) {
        onError?.(`"${file.name}" is too large (max 10MB).`);
        continue;
      }
      accepted.push(file);
    }
    if (accepted.length) setFiles(prev => [...prev, ...accepted]);
  };

  return (
    <div className="field">
      <label>{label}</label>
      <div className="file-upload-box">
        <input type="file" multiple accept={ACCEPTED_FILE_TYPES}
          onChange={e => { addFiles(e.target.files); e.target.value = ""; }}/>
        <div className="file-upload-icon">📎</div>
        <div className="file-upload-txt">Click to upload or drag files here</div>
        <div className="file-upload-sub">{hint || "PDF, Word or image files, max 10MB each"}</div>
      </div>
      {files.length > 0 && (
        <div className="file-list">
          {files.map((f, i) => (
            <div className="file-chip" key={`${f.name}-${i}`}>
              <span className="fc-name">{f.name}</span>
              <span className="fc-size">{fmtSize(f.size)}</span>
              <button type="button" className="fc-remove"
                onClick={() => setFiles(prev => prev.filter((_, idx) => idx !== i))}
                aria-label={`Remove ${f.name}`}>×</button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
